export interface CityCenter {
  lat: number;
  lng: number;
  uf: string;
}

export const FALLBACK_MAP_CENTER = { lat: -3.7301571, lng: -38.5144071 };

const CITY_CENTERS: Record<string, CityCenter> = {
  fortaleza: { lat: -3.7301571, lng: -38.5144071, uf: "CE" },
  recife: { lat: -8.047562, lng: -34.877006, uf: "PE" },
  "sao paulo": { lat: -23.55052, lng: -46.633308, uf: "SP" },
  salvador: { lat: -12.9714, lng: -38.5014, uf: "BA" },
  teresina: { lat: -5.08921, lng: -42.8016, uf: "PI" },
  maceio: { lat: -9.66599, lng: -35.735, uf: "AL" },
};

export function normalizeCityName(value: string): string {
  return value
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim();
}

export function getCityCenter(
  city?: string | null,
  _uf?: string | null
): { lat: number; lng: number } | null {
  if (!city?.trim()) {
    return null;
  }

  const cityCenter = CITY_CENTERS[normalizeCityName(city)];
  if (!cityCenter) {
    return null;
  }

  return { lat: cityCenter.lat, lng: cityCenter.lng };
}
